import { OverlayTrigger, Tooltip, Button } from "react-bootstrap";
import { endpointsCf } from "../../../../../config/componentsConfig";
import { getDocument } from 'pdfjs-dist';
import { useMsal } from "@azure/msal-react";
import { useState } from "react";
import useFetchWithMsal from "../../../../../hooks/useFetchWithMsal";
import styles from "./FileUploadPB.module.scss";
import { Form } from "react-bootstrap";
import { v4 as uuidv4 } from 'uuid';
import { TaskType, useTasksContext, TaskStatus } from "../../../../../contexts/TasksContext";

const AUTHORIZED_FILES_NUMBER = 15;

const DocumentUploadButton = ({filesNumber, setSelectedMenu}: {filesNumber: number, setSelectedMenu: (selectedMenu: number) => void}) => {

  const { execute } = useFetchWithMsal();
  const { instance } = useMsal();
  const activeAccount = instance.getActiveAccount();
  const [fastUpload, setFastUpload] = useState(true);
  const { addTask } = useTasksContext();


  const getTotalPages = async (file: File): Promise<number> => {
    return new Promise((resolve) => {
      const reader = new FileReader();
      
      reader.onload = async (e) => {
        try {
          if (!e.target?.result) {
            console.error('❌ Erreur de lecture du fichier');
            resolve(0);
            return;
          }

          const arr = new Uint8Array(e.target.result as ArrayBuffer);
          
          try {
            const loadingTask = getDocument({ data: arr });
            const pdf = await loadingTask.promise;
            console.log(`📚 Nombre de pages détecté pour ${file.name}: ${pdf.numPages}`);
            resolve(pdf.numPages);
          } catch (error) {
            console.error('❌ Erreur lors de la lecture du PDF:', error);
            
            try {
              const blob = new Blob([arr], { type: 'application/pdf' });
              const url = URL.createObjectURL(blob);
              const loadingTask = getDocument(url);
              const pdf = await loadingTask.promise;
              console.log(`📚 Nombre de pages détecté (2ème tentative) pour ${file.name}: ${pdf.numPages}`);
              URL.revokeObjectURL(url);
              resolve(pdf.numPages);
            } catch (error2) {
              console.error('❌ Échec de la lecture du PDF');
              resolve(0);
            }
          }
        } catch (error) {
          console.error('❌ Erreur générale:', error);
          resolve(0);
        }
      };

      reader.onerror = (error) => {
        console.error('❌ Erreur de lecture:', error);
        resolve(0);
      };

      reader.readAsArrayBuffer(file);
    });
  };


  const handleFileUpload = async (files: FileList) => {
    if (!files.length || !activeAccount) return;

      const formData = new FormData();
    formData.append('userId', activeAccount.username);
      
    console.log('📁 Fichiers sélectionnés:', Array.from(files).map(f => f.name));

      const filesWithPages = await Promise.all(
        Array.from(files).map(async (file) => {
        const totalPages = await getTotalPages(file);
        
        if (totalPages === 0) {
          console.error(`❌ Erreur: Impossible de lire le nombre de pages pour ${file.name}`);
          return null;
        }
          return {
            file,
          totalPages
          };
        })
      );

    // Filtrer les fichiers qui n'ont pas pu être lus
    const validFiles = filesWithPages.filter((f): f is NonNullable<typeof f> => f !== null);
    
    if (validFiles.length === 0) {
      console.error('❌ Aucun fichier n\'a pu être lu correctement');
      return;
    }

    validFiles.forEach(({ file }) => {
        formData.append('files', file);
      });

      formData.append('fastUpload', fastUpload.toString());

      const processFiles = validFiles.map(({ file, totalPages }) => ({
          filename: file.name,
          totalPages,
          processed: 0
      }));

      const task = {
        id: uuidv4(),
        type: TaskType.UPLOAD,
        timestamp: Date.now(),
        createdAt: Date.now(),
        updatedAt: Date.now(),
        file: {
          filename: processFiles[0].filename,
          nbPages: processFiles[0].totalPages,
          nbProcessed: 0,
          nbProcessedSummary: 0,
          status: "pending"
        },
        status: TaskStatus.PROCESSING
      };

      addTask(task);
      setSelectedMenu(5);

      try {
        const uploadResponse = await execute('POST', endpointsCf.upload, formData);
        console.log('⬆️ Réponse upload:', uploadResponse);
          
        

      } catch (error) {
      console.error('❌ Erreur lors de l\'upload:', error);
      }
    };


    return (
        <div className="d-flex flex-column align-items-center justify-content-center" style={{width: "100%", height: "100%", padding: 20}}>
            <OverlayTrigger
            placement="top"
            delay={{ show: 400, hide: 200 }}
            overlay={
              <Tooltip id="tooltip-upload">
                {filesNumber >= AUTHORIZED_FILES_NUMBER ? "You have reached the maximum number of documents" : "Upload documents"}
              </Tooltip>
            }
          >
            <button 
              className={styles.fileUploadButton}
              disabled={filesNumber >= AUTHORIZED_FILES_NUMBER}
              onClick={() => {
                const input = document.createElement('input');
                input.type = 'file';
                input.accept = '.pdf';
                input.onchange = (e) => handleFileUpload((e.target as HTMLInputElement).files!);
                input.click();
              }}
            >
              <i className="bi bi-plus" style={{color: "#4AAFCE"}}></i>
              <div style={{fontSize: "0.8rem", color: "#4AAFCE"}}>Upload a new document in my personal secure environment. Georges will only extract text, not images/scans.</div>
            </button>
          </OverlayTrigger>
          {/*<Form>
            <Form.Check // prettier-ignore
              type="switch"
              title="Do not modify - only for advanced usage"
              label={fastUpload ? "Fast Upload (Text only)" : "Slow Upload (Text and images) - Advanced usage only"}
              checked={fastUpload}
              onChange={(e) => setFastUpload(e.target.checked)}
              style={{color: "grey", fontSize: 12, marginTop: "10px"}}
            />
          </Form>*/}
        </div>
    )
}

export default DocumentUploadButton;
